export default "__VITE_ASSET__CBpGj_sH__"